import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const KidsMenu = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/' name='Дитяче меню'/>
            <main className={s.main}>
                <Product name='Дитячий чизбургер з картоплею фрі ' price='130 грн.' weight='190г.' info1='булочка, котлета куряча, листя салату, помідор, огірок маринований, соус бургерний, соус сирний, сир тостовий'/>
                <Product name='Картопля фрі' price='50 грн.' weight='130г.' info1='з кетчупом'/>
                <Product name='Картопляне пюре з курячою відбивною' price='110 грн.' weight='300г.'/>
                <Product name='Корн – дог з сосискою' price='45 грн.' weight='80г.'/>
                <Product name='Сирні палички' price='120 грн.' weight='150г.'/>
                <Product name='Нагетси' price='100 грн.' weight='100г.'/>
                <Product name='Сирні кульки' price='110 грн.' weight='150г.'/>
                <Product name='Сосиска в спиральній чипсі' price='60 грн.' weight='80г.'/>
                <Product name='Курячі крила' price='110 грн.' weight='200г.'/>
                <Product name='Спиральні чипси' price='50 грн.' weight='50г.'/>
                <Product name='Піца «Бейбі»' price='150 грн.' weight='500г.' info1='кетчуп лагідний, курка запечена, помідори черрі, помідори, моцарела, маслини, ананас консервований'/>
                <Product name='Фруктовий салат' price='100 грн.' weight='260г.' info1='ківі, банан, апельсин, ананас, мандарин, виноград, вершки, топінг, повітряний рис в молочному шоколаді'/>
                <p>Напої</p>
                <Product name='Какао' price='25 грн.' weight='250мл.' info1='Добавки:' info2='Маршмеллоу – 10г/9грн' info3='Шоколадні дропси – 5г/9грн' />
                <Product name='Гарячий шоколад ' price='40 грн.' weight='200мл.'/>
                <Product name='Банановий коктейль (гарячий)' price='60 грн.' weight='280мл.' info1="банан, молоко, банановий сироп, вершки, банановий топінг"/>
                <Product name='Бейбічино ' price='30 грн.' weight='250мл.' info1='молоко, сироп на вибір'/>
                <Product name='Молоко' price='20 грн.' weight='250мл.'/>
            </main>
        </div>
    )
}

export default KidsMenu;